import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking
    const [ready, setReady] = useState(false);

    const fetchMe = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            setUser(false);
        } finally {
            setReady(true);
        }
    }, []);

    useEffect(() => {
        fetchMe();
    }, [fetchMe]);

    // Poll balance to keep the navbar bubble fresh (simple realtime alternative)
    useEffect(() => {
        const t = setInterval(() => {
            if (user && user !== false) fetchMe();
        }, 10000);
        return () => clearInterval(t);
    }, [user, fetchMe]);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    };

    const register = async (email, password, username, referral_code) => {
        const body = { email, password, username };
        if (referral_code) body.referral_code = referral_code;
        const { data } = await api.post("/auth/register", body);
        setUser(data);
        return data;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } finally {
            setUser(false);
        }
    };

    const refresh = fetchMe;

    return (
        <AuthContext.Provider value={{ user, ready, login, register, logout, refresh, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
